import React from 'react';
import { motion } from 'framer-motion';
import { MapPinIcon, TrophyIcon } from 'lucide-react';
interface VenueWelcomeProps {
  onStart: () => void;
  onViewLeaderboard: () => void;
}
export function VenueWelcome({
  onStart,
  onViewLeaderboard
}: VenueWelcomeProps) {
  return <div className="flex flex-col h-full relative overflow-hidden bg-brand-green-deep" data-id="element-395">
      {/* Background Gradient */}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_right,rgba(184,150,90,0.2)_0%,transparent_60%)]" data-id="element-396" />
      <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0IiBoZWlnaHQ9IjQiPgo8cmVjdCB3aWR0aD0iNCIgaGVpZ2h0PSI0IiBmaWxsPSIjZmZmIiBmaWxsLW9wYWNpdHk9IjAuMDUiLz4KPC9zdmc+')] opacity-20 mix-blend-overlay" data-id="element-397" />

      <div className="relative z-10 flex-1 flex flex-col p-8" data-id="element-398">
        {/* Header */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.1
      }} className="text-center mt-8 mb-auto" data-id="element-399">
          <img src="https://cdn.magicpatterns.com/uploads/gKLHbH1tZvpadqrKuZmtrQ/image.png" alt="Living Luxe Show" className="w-16 h-16 object-contain mx-auto mb-3 rounded-lg bg-white/90 p-1.5" data-id="element-400" />
          <div className="inline-flex items-center justify-center space-x-2 bg-brand-cream/10 px-4 py-1.5 rounded-full backdrop-blur-sm border border-brand-cream/10 mb-6" data-id="element-401">
            <MapPinIcon className="w-4 h-4 text-brand-gold" data-id="element-402" />
            <span className="text-xs font-body text-brand-cream-light uppercase tracking-widest" data-id="element-403">
              Toronto Congress Centre
            </span>
          </div>
          <h1 className="text-4xl font-heading text-brand-cream-light mb-4 leading-tight" data-id="element-404">
            Living Luxe
            <br data-id="element-405" />
            Show
          </h1>
          <p className="text-brand-cream/70 font-body text-sm max-w-[240px] mx-auto" data-id="element-406">
            A premium 3-hole putting experience designed by PuttLab.
          </p>
        </motion.div>

        {/* Actions */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.3
      }} className="mt-auto space-y-4" data-id="element-407">
          <button onClick={onStart} className="w-full bg-brand-gold text-brand-charcoal font-heading text-xl py-5 rounded-xl shadow-lg hover:bg-brand-gold-light transition-colors active:scale-[0.98]" data-id="element-408">
            Start Playing
          </button>

          <button onClick={onViewLeaderboard} className="w-full flex items-center justify-center space-x-2 bg-brand-cream-light/5 text-brand-cream-light font-body py-4 rounded-xl border border-brand-cream/10 hover:bg-brand-cream-light/10 transition-colors active:scale-[0.98]" data-id="element-409">
            <TrophyIcon className="w-5 h-5 text-brand-gold" data-id="element-410" />
            <span data-id="element-411">View Leaderboard</span>
          </button>
        </motion.div>
      </div>
    </div>;
}